<template>
  <a-drawer width="55%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" labelAlign="left" :model="form" :rules="rules">
      <a-row>

      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="activityName" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('活动标题') }}<template slot="title">{{ $t('活动标题') }}</template></a-tooltip> </span>
            <a-input v-model="form.activityName" :maxLength="100" :placeholder="$t('请输入')+'活动标题'">
              <locale-field-button
                slot="suffix"
                class="ant-input-suffix-button"
                v-model="form.localeFieldMap['activityName']"
                input-type="input"
                table-name="activity_activity"
                table-field="activityName"
                :field-value="form.activityName"/>
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="coverImg" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('活动封面图') }}<template slot="title">{{ $t('活动封面图') }}</template></a-tooltip> </span>
            <oss-upload-single :height="100" :width="100"  v-model="form.coverImg" prefix="activity" type="img"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="posterImg" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('分享海报图') }}<template slot="title">{{ $t('分享海报图') }}</template></a-tooltip> </span>
            <oss-upload-single :height="100" :width="100"  v-model="form.posterImg" prefix="activity" type="img"/>
          </a-form-model-item>
        </a-col>
      </a-row>
<!--      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="posterTxt" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('分享文案') }}<template slot="title">{{ $t('分享文案') }}</template></a-tooltip> </span>
            <a-input v-model="form.posterTxt" :maxLength="300" :placeholder="$t('请输入')+'分享文案'">
              <locale-field-button
                slot="suffix"
                class="ant-input-suffix-button"
                v-model="form.localeFieldMap['posterTxt']"
                input-type="input"
                table-name="activity_activity"
                table-field="posterTxt"
                :field-value="form.posterTxt"/>
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>-->
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="activityType" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('活动类型') }}<template slot="title">{{ $t('活动类型') }}</template></a-tooltip> </span>
            <a-radio-group :disabled="formType===2"  v-model="form.activityType" button-style="solid" @change="activityChange()">
              <a-radio-button v-for="(item, index) in this.customDict.ActivityUsefulTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.activityType === 14">
        <!--    秒杀活动金额    -->
        <a-card v-for="(item, index) in form.discountItemList">
          <a-form-model-item layout="inline" label="秒杀金额" :prop="`discountItemList.${index}.discount`" :rules='rules.discount'  :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-input-number v-model="item.discount" style="width: 50%" :step="0.01" :precision="2"  :min="1" :max="999999"  :maxLength="32" placeholder="请输入秒杀金额"/>
            <span>元 </span>
          </a-form-model-item>
        </a-card>
      </a-row>
      <a-row v-if="form.activityType === 11">
        <!--    满减活动    -->
        <a-col :span="24">
          <a-form-model-item prop="discountType" :label-col="{span: 3}" :wrapper-col="{span: 20}">
            <span slot="label"><a-tooltip>{{ $t('减免类型') }}<template slot="title">{{ $t('减免类型') }}</template></a-tooltip> </span>
            <a-radio-group v-model="form.discountType" button-style="solid" @change="discountTypeChange">
              <a-radio-button v-for="(item, index) in this.customDict.ActivityDiscountTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.activityType === 21">
        <!--    折扣活动    -->
        <a-card v-for="(item, index) in form.discountItemList">
          <a-form-model-item layout="inline" label="折扣" :prop="`discountItemList.${index}.discount`" :rules='rules.discount'  :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
            <a-input-number v-model="item.discount" style="width: 50%" :step="1" :min="1" :max="10"  :maxLength="32" placeholder="请输入折扣"/>
            <span>折&nbsp;&nbsp;&nbsp;&nbsp;请输入大于0小于10的数字 </span>
          </a-form-model-item>
        </a-card>
      </a-row>
      <a-row v-if="form.activityType === 11">
        <!--    满减活动层级    -->
        <a-col :span="24" v-for="(item, index) in (form.discountItemList || [])" :key="'full-minus-tier-' + index">
          <a-card :bordered="true">
            <template slot="title">
              <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                <span>活动层级 {{ index + 1 }}</span>
                <a-button v-if="(form.discountItemList || []).length > 1" type="link" danger style="padding: 0; height: auto; line-height: inherit;" @click="removeDiscountTier(index)">
                  <a-icon type="delete" />删除
                </a-button>
              </div>
            </template>
            <a-col :span="12">
              <a-form-model-item :prop="`discountItemList.${index}.cashCondition`" :rules="rules.cashCondition" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <span slot="label">使用条件 满</span>
                <a-input-number v-model="item.cashCondition" style="width: 100%" :max="9999999" :min="0.01" :precision="2" :step="0.01" placeholder="请输入大于0的整数或者保留两位小数的正数"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :prop="`discountItemList.${index}.discount`" :rules="rules.fullMinusDiscount" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
                <span slot="label">金额 减</span>
                <a-input-number v-model="item.discount" style="width: 100%" :max="9999999" :min="0.01" :precision="2" :step="0.01" placeholder="请输入大于0的整数或者保留两位小数的正数"/>
              </a-form-model-item>
            </a-col>
          </a-card>
        </a-col>
        <a-col :span="21" :offset="0" style="margin-bottom: 16px;" v-if="form.discountType===1">
          <a-button type="dashed" @click="addDiscountTier">
            <a-icon type="plus" />添加满减层级
          </a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="suitableType" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('适用商品类型') }}<template slot="title">{{ $t('适用商品类型 ') }}</template></a-tooltip> </span>
            <a-radio-group v-model="form.suitableType" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponSuitableTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12" v-if="form.suitableType===2">
          <a-form-model-item prop="goodsList"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <a-button type="dashed"  v-if="form.goodsList!=null && form.goodsList.length > 0" style="text-align: left; width: 100%" @click="openGoodsSelect" danger>
              <span style="color: dodgerblue">已选择{{form.goodsList.length}}件商品</span>
            </a-button>
            <a-button v-else plain type="primary" @click="openGoodsSelect">选择商品</a-button>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="startTime" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('开始时间') }}<template slot="title">{{ $t('开始时间') }}</template></a-tooltip> </span>
            <a-date-picker style="width: 100%" v-model="form.startTime"  :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="endTime" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('结束时间') }}<template slot="title">{{ $t('结束时间') }}</template></a-tooltip> </span>
            <a-date-picker style="width: 100%" v-model="form.endTime"  :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col  :span="24">
          <a-form-model-item prop="timeType"  :label-col="{span: 3}" :wrapper-col="{span: 16}">
            <span slot="label" >
              使用时间段
              <a-tooltip><template slot="title">使用时间段</template></a-tooltip>
            </span>
            <a-radio-group v-model="form.timeType" :disabled="formType===2">
              <a-radio v-for="(item, index) in this.customDict.ActivityTimeTypeEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="24" v-if="form.timeType===2 " style="padding-left: 50px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" style="width: 50%">
            每天<a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm" />
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div style="width: 50%">
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.timeType===3 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" >
            <a-select mode="multiple" placeholder="请选择周" style="width: 55%" v-model="activityTime.dayOfWeekList" allowClear>
              <a-select-option v-for="(item, index) in customDict.DayOfWeekEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
        <a-col :span="24" v-if="form.timeType===4 " style="padding-left: 20px;">
          <a-card v-for="(activityTime, index) in form.useEffectiveTimeList" :key="index" >
            <a-select  mode="multiple" placeholder="请选择月" style="width: 55%" v-model="activityTime.monthOfYearList" allowClear>
              <a-select-option v-for="(item, index) in customDict.MonthOfYearEnum" :value="item.type" :key="index">{{ item.name }}</a-select-option>
            </a-select>
            <a-time-picker v-model="activityTime.startTime" format="HH:mm" valueFormat="HH:mm" />-
            <a-time-picker v-model="activityTime.endTime" format="HH:mm" valueFormat="HH:mm"/>
            <a-button type="link" v-if="formType===1" style="color: red"  @click="delUseTimeRange(index)"><a-icon type="delete" />删除</a-button>
          </a-card>
          <div>
            <a-button type="link" v-if="formType===1" @click="addUseTimeRange"><a-icon type="plus" />添加时段</a-button>
          </div>
        </a-col>
      </a-row>


      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="limitMember" :label-col="{span: 3}" :wrapper-col="{span: 20}">
            <span slot="label"><a-tooltip>{{ $t('限制会员等级') }}<template slot="title">{{ $t('限制会员等级') }}</template></a-tooltip> </span>
            <a-select placeholder="请选择限制会员等级" style="width: 100%" v-model="form.limitMemberList" mode="multiple" allowClear>
              <a-select-option v-for="(item, index) in levelList" :value="item.id" :key="index">
                {{ item.levelName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item prop="status" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('状态') }}<template slot="title">{{ $t('状态') }}</template></a-tooltip> </span>
            <a-radio-group v-model="form.status" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.CouponStatusEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="isLimit" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('是否限量') }}<template slot="title">{{ $t('是否限量') }}</template></a-tooltip> </span>
            <a-radio-group v-model="form.isLimit" button-style="solid">
              <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row v-if="form.isLimit">
        <a-col :span="12">
          <a-form-model-item prop="stock"  :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('库存') }}<template slot="title">{{ $t('库存') }}</template></a-tooltip> </span>
            <a-input-number v-model="form.stock" style="width: 100%" :min="0" :max="9999999" :placeholder="$t('请输入')+'库存'"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item prop="limitNum" :label-col="{span: 6}" :wrapper-col="{span: 16}">
            <span slot="label"><a-tooltip>{{ $t('用户参与上限') }}<template slot="title">{{ $t('用户参与上限') }}</template></a-tooltip> </span>
            <a-input-number v-model="form.limitNum" style="width: 100%" :min="0" :max="100" :placeholder="$t('请输入')+'用户参与上限'"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item prop="remark" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <span slot="label"><a-tooltip>{{ $t('备注') }}<template slot="title">{{ $t('备注') }}</template></a-tooltip> </span>
            <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <goods-checkbox-select ref="goodsSelect" @goodsSelect="handleGoodsSelected"></goods-checkbox-select>
  </a-drawer>
</template>

<script>
import {getActivity, addActivity, updateActivity} from '@/api/activity/activity'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import GoodsCheckboxSelect from "@/views/goods/goods/select/GoodsCheckboxSelect.vue";
import moment from 'moment';

export default {
  name: 'CreateForm',
  props: {
    levelList:{
      require: true,
      type: Array
    }
  },
  components: {
    GoodsCheckboxSelect,
    OssUploadSingle,
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      moment,
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        goodsList: [],
        timeType: 1,
        useEffectiveTimeList: [],
        merchantScope: 3,
        activityType: 14,
        activityName: null,
        coverImg: null,
        posterImg: null,
        posterTxt: null,
        suitableType: 1,
        discountType: 1,
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        endTime: null,
        limitMember: null,
        status: true,
        isLimit: false,
        limitNum: null,
        stock: null,
        remark: null,
        discountItemList: [],
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        activityType: [{required: true, message: this.$t('活动类型') + this.$t('不能为空'), trigger: 'change'}],
        suitableType: [{required: true, message: this.$t('使用商品类型') + this.$t('不能为空'), trigger: 'change'}],
        discountType: [{required: true, message: this.$t('减免类型') + this.$t('不能为空'), trigger: 'change'}],
        activityName: [{required: true, message: this.$t('活动标题') + this.$t('不能为空'), trigger: 'blur'}],
        coverImg: [{required: true, message: this.$t('活动封面图') + this.$t('不能为空'), trigger: 'blur'}],
        stock: [{required: true, message: this.$t('库存') + this.$t('不能为空'), trigger: 'blur'}],
        status: [{required: true, message: this.$t('状态') + this.$t('不能为空'), trigger: 'change'}],
        limitNum: [{required: true, message: this.$t('用户参与上限') + this.$t('不能为空'), trigger: 'blur'}],
        discount: [{required: true, message: this.$t('折扣') + this.$t('不能为空'), trigger: 'blur'}],
        cashCondition: [{required: true, message: '使用条件（满额）' + this.$t('不能为空'), trigger: 'blur'}],
        fullMinusDiscount: [{required: true, message: '减免金额' + this.$t('不能为空'), trigger: 'blur'}],
        limitMemberList: [{ required: true, message: '限制会员等级'+this.$t('不能为空'), trigger: 'change' }],
        startTime: [{required: true, message: this.$t('开始时间') + this.$t('不能为空'), trigger: 'change'}],
        endTime: [{required: true, message: this.$t('结束时间') + this.$t('不能为空'), trigger: 'change'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        goodsList: [],
        timeType: 1,
        useEffectiveTimeList: [],
        merchantScope: 3,
        activityType: 14,
        activityName: null,
        coverImg: null,
        posterImg: null,
        posterTxt: null,
        suitableType: 1,
        discountType: 1,
        startTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        endTime: null,
        limitMember: null,
        status: true,
        isLimit: false,
        limitNum: null,
        stock: null,
        remark: null,
        discountItemList: [],
        localeFieldMap: {},
      }

    },

    openGoodsSelect() {
      let merchantId = this.form.merchantId
      this.$refs.goodsSelect.openGoods(this.form.goodsList, [merchantId],[20,21]);
    },
    handleGoodsSelected(list) {
      this.form.goodsList = list
    },

    initLimitMember() {
      this.form.limitMemberList = []
      this.levelList.forEach(item => {
        this.form.limitMemberList.push(item.id)
      })
    },

    addUseTimeRange() {
      let data = {"dayOfWeekList": [], "monthOfYearList": [], "startTime": undefined, "endTime": undefined};
      if (!this.form.useEffectiveTimeList) {
        this.form.useEffectiveTimeList = []
      }
      this.form.useEffectiveTimeList.push(data);
    },
    delUseTimeRange(index) {
      this.form.useEffectiveTimeList.splice(index, 1)
    },

    discountTypeChange() {
      if (this.form.discountType === 2 && this.form.activityType === 11) {
        this.form.discountItemList = []
        this.form.discountItemList.push({ cashCondition: undefined, discount: undefined })
      }
    },

    activityChange() {
      if (this.form.activityType === 21) {
        const discountItem = { discount: 10 }
        this.form.discountItemList = []
        this.form.discountItemList.push(discountItem)
      } else if (this.form.activityType === 14) {
        const discountItem = { discount: 1}
        this.form.discountItemList = []
        this.form.discountItemList.push(discountItem)
      } else if (this.form.activityType === 11) {
        this.form.discountItemList = []
        this.form.discountItemList.push({ cashCondition: undefined, discount: undefined })
      }
    },

    addDiscountTier() {
      if (!this.form.discountItemList) {
        this.$set(this.form, 'discountItemList', [])
      }
      this.form.discountItemList.push({ cashCondition: undefined, discount: undefined })
    },

    removeDiscountTier(index) {
      if (!this.form.discountItemList || this.form.discountItemList.length <= 1) {
        return
      }
      this.form.discountItemList.splice(index, 1)
    },

    /** 新增按钮操作 */
    handleAdd(merchantId) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      this.initLimitMember()
      this.form.merchantId =merchantId

    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getActivity({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateActivity(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addActivity(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

